import { defineMessages } from 'react-intl';

/** The copy of the Media numbers on the SmartLink stats (design smartlink-media-block c). */
export const mediaStatsMessages = defineMessages({
  playsCard: { id: 'app.sml.stats.media.playsCard', defaultMessage: 'Video plays' },
  playsCardHint: { id: 'app.sml.stats.media.playsCard.hint', defaultMessage: '{percent} watched on average' },
  playsCardHintNone: { id: 'app.sml.stats.media.playsCard.hintNone', defaultMessage: 'no plays yet' },
  playsLine: { id: 'app.sml.stats.media.playsLine', defaultMessage: 'Video plays' },
  title: { id: 'app.sml.stats.media.title', defaultMessage: 'Media' },
  perBlock: { id: 'app.sml.stats.media.perBlock', defaultMessage: 'per block' },
  kindVideo: { id: 'app.sml.stats.media.kind.video', defaultMessage: 'Video' },
  kindImage: { id: 'app.sml.stats.media.kind.image', defaultMessage: 'Image' },
  position: { id: 'app.sml.stats.media.position', defaultMessage: 'block {position}' },
  removed: { id: 'app.sml.stats.media.removed', defaultMessage: 'Removed' },
  seen: { id: 'app.sml.stats.media.seen', defaultMessage: 'Seen' },
  seenHint: { id: 'app.sml.stats.media.seen.hint', defaultMessage: '{percent} of views' },
  plays: { id: 'app.sml.stats.media.plays', defaultMessage: 'Plays' },
  playsHint: { id: 'app.sml.stats.media.plays.hint', defaultMessage: '{percent} of seen' },
  avgWatched: { id: 'app.sml.stats.media.avgWatched', defaultMessage: 'Avg watched' },
  avgWatchedHint: { id: 'app.sml.stats.media.avgWatched.hint', defaultMessage: '{seconds} s of {length} s' },
  soundOn: { id: 'app.sml.stats.media.soundOn', defaultMessage: 'Sound on' },
  soundOnHint: { id: 'app.sml.stats.media.soundOn.hint', defaultMessage: '{percent} of plays' },
  clicks: { id: 'app.sml.stats.media.clicks', defaultMessage: 'Clicks' },
  clicksHint: { id: 'app.sml.stats.media.clicks.hint', defaultMessage: '{percent} of seen' },
  people: { id: 'app.sml.stats.media.people', defaultMessage: 'People' },
  peopleHint: { id: 'app.sml.stats.media.people.hint', defaultMessage: 'who saw it' },
  started: { id: 'app.sml.stats.media.funnel.started', defaultMessage: 'Started' },
  finished: { id: 'app.sml.stats.media.funnel.finished', defaultMessage: 'Finished' },
  funnelLabel: { id: 'app.sml.stats.media.funnel.label', defaultMessage: 'How far the plays got' },
  perDay: { id: 'app.sml.stats.media.perDay', defaultMessage: 'Per day' },
  switchPlays: { id: 'app.sml.stats.media.switch.plays', defaultMessage: 'Plays' },
  switchSeen: { id: 'app.sml.stats.media.switch.seen', defaultMessage: 'Seen' },
  emptyVideo: {
    id: 'app.sml.stats.media.empty.video',
    defaultMessage: 'No plays yet. Numbers appear once fans scroll to the video.',
  },
  emptyImage: {
    id: 'app.sml.stats.media.empty.image',
    defaultMessage: 'Nothing yet. Numbers appear once fans scroll to the picture.',
  },
  emptyNote: {
    id: 'app.sml.stats.media.empty.note',
    defaultMessage: 'Plays count from the day the block went live. Older days show no media numbers.',
  },
  howTitle: { id: 'app.sml.stats.media.how.title', defaultMessage: 'How we count' },
  howSeen: {
    id: 'app.sml.stats.media.how.seen',
    defaultMessage: 'Seen: half of the block was on the screen for 1 second.',
  },
  howPlay: {
    id: 'app.sml.stats.media.how.play',
    defaultMessage: 'Play: a fan tapped play, or a muted autoplay ran for 3 seconds.',
  },
  howWatched: {
    id: 'app.sml.stats.media.how.watched',
    defaultMessage: 'Watched: the furthest point of each play, as a share of the length.',
  },
  howPrivacy: {
    id: 'app.sml.stats.media.how.privacy',
    defaultMessage: 'No cookies. The same anonymous daily visitor count as the page.',
  },
  blockRow: { id: 'app.sml.stats.media.blockRow', defaultMessage: 'Media · {label}' },
});
